import React from "react";
import { connect } from "react-redux";
import { SurveyPageType } from "../../../store/Models/Surveys/SurveyDataModel";
import { InventoryDetailsResponse } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels";
import { NavContext } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { ToxnotReactModal, ToxnotReactModalBody } from "../ToxnotReactModal";
import { RedirectLink } from "../RedirectLink";
import { ApplicationState } from "../../../store";
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";

import "./styles.css";
import { SparklesIcon } from "../../shared/SparklesIcon";

interface CommonModalEditorProps {
    modalId: string;
    localizer: IStringLocalizer;
    navContext: NavContext | undefined;
    responseId: string;
    selectedInventory: InventoryDetailsResponse | null;
    userId: string;
    handleClickImportMaterial: any;
}

interface StateProps {
    appServices: ApplicationState["appServices"];
}

interface DispatchProps {
    setMainNavPage: (
        pageType: SurveyPageType,
        questionnaireIndex?: number,
        questionnairePageIndex?: number,
        previousPageStack?: number[]
    ) => any;
}

type Props = CommonModalEditorProps & StateProps & DispatchProps;

const CommonModalEditor: React.FC<Props> = ({ modalId, localizer, navContext, responseId, selectedInventory, userId, handleClickImportMaterial, appServices, setMainNavPage }) => {
    const redirectLinkState = {
        responseId: responseId,
        surveyResponseInventoryId: selectedInventory?.inventoryId
    }

    const handleClickImport = () => {
        const id = '#' + modalId;
        $(id).modal("hide");
    };

    const handleAiDocProcessorClick = () => {
        // Emit analytics
        appServices?.trackEvent("survey.ai_button_clicked", { page_context: "modal" });
        // Navigate to Bulk Inputs (Batch)
        setMainNavPage(SurveyPageType.Batch);
        // Hide the modal
        $('#' + modalId).modal('hide');
    };

    return (
        <ToxnotReactModal
            modalId={modalId.toString()}
            customHeader={
                <div>
                    <h4 className="modal-title">{localizer.localizeString("Choose a way to import")}</h4>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            }>
            <ToxnotReactModalBody>
                <div className="start-subcontent-content-container">
                    {/* Auto-answer with AI card at the top */}
                    <div
                        className="selector-div ai-doc-processor-card"
                        onClick={handleAiDocProcessorClick}
                    >
                        <div className="ai-doc-processor-content">
                            <div className="ai-doc-processor-header">
                                <span className="ai-doc-processor-title">
                                    <SparklesIcon width={22} height={22} color="#0e4876" style={{ marginRight: 8, flexShrink: 0 }} />
                                    <span>{localizer.localizeString("Auto-answer with AI")}</span>
                                </span>
                            </div>
                            <div className="ai-doc-processor-desc">
                                {localizer.localizeString("Use AI to extract data from your documents")}
                            </div>
                        </div>
                    </div>
                    {/* Import options grid below */}
                    <div className="selectors-container">
                        {(navContext?.mainNavIndex !== SurveyPageType.SupplierQuestionnaire ?? true) &&
                            <div className="selector-div" onClick={() => window.open(`/Data/NewProduct?responseId=${responseId}&inventoryId=${selectedInventory?.inventoryId}&mode=Component`, "_blank")}>
                                <div className="title">{localizer.localizeString("Excel Spreadsheet")}</div>
                                <div className="description">{localizer.localizeString("Import BOM data via an excel Spreadsheet")}
                                </div>
                            </div>
                        }
                        {(navContext?.mainNavIndex !== SurveyPageType.SupplierQuestionnaire ?? true) &&
                            <div className="selector-div" onClick={() => window.open(`/Data/NewProduct?responseId=${responseId}&inventoryId=${selectedInventory?.inventoryId}&mode=MSDS%20Library`, "_blank")}>
                                <div className="title">{localizer.localizeString("Safety Data Sheet (SDS)")}</div>
                                <div className="description"></div>
                            </div>
                        }
                        <div className="selector-div" onClick={handleClickImportMaterial}>
                            <div className="title">{localizer.localizeString("Select from My Materials")}</div><div className="description">{localizer.localizeString("Import Material")}</div>
                        </div>
                        <RedirectLink 
                            handleClickImport={handleClickImport}
                            state={redirectLinkState}
                            localizer={localizer}
                            pathname={"/Exchange/Management/MyPassports"}>
                        </RedirectLink>
                    </div>
                </div>
            </ToxnotReactModalBody>
        </ToxnotReactModal>
    );
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    appServices: state.appServices
});

const mapDispatchToProps: DispatchProps = {
    setMainNavPage: SurveyResponseController.actionCreators.setMainNavPage
};

export default connect(mapStateToProps, mapDispatchToProps)(CommonModalEditor);
